import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { analytics } from 'core/analytics';

import { html } from 'libs/editor/serializers/html';
import { EditorStore } from 'libs/editor/store';
import { Editor } from 'libs/editor';
import DocumentHead from 'legacyComponents/documentHead';
import { HeaderMarginTop as Main, Divider } from 'legacyComponents/styled/lib';

import { imageSrc } from 'apps/file/utils';
import Like from 'apps/content/views/like';

import { SectionBanner, Paragraph, Box } from 'components';
import { TagLinks } from 'apps/story/views/tagLinks';
import { AuthorDetails } from 'apps/story/views/authorDetails';
import { StoryInfo } from 'apps/story/views/storyInfo';
import { Comments } from 'apps/story/views/comments';
import { StoryIndicator } from 'apps/story/views/storyIndicator';
import { StoryWrapper, Title, Article, CoverImage } from 'apps/story/styles';

import Header from 'apps/components/header/header';

import { conf as mainConf } from 'apps/config.yaml';

@observer
export class StoryView extends React.Component {
  constructor(props) {
    super(props);
    analytics.sendEvent('ViewContent', {}, { twitter: true, facebook: true });
    analytics.linkedinPixel('1169129');
  }

  render() {
    const { story, params, loading } = this.props;

    if (loading || !story) {
      return (
        <main>
          <Header />
          <StoryIndicator />
        </main>
      );
    }
    const { avatar, title } = story;
    const src = imageSrc(
      avatar,
      story.imageFallbackPath,
      mainConf.imgSizes.story.large,
    );
    // FIXME - look into avoiding store creation during render
    const store = new EditorStore({
      initialValue: html.deserialize(story.body || '<p></p>'),
      formatting: 'advanced',
    });

    return (
      <Main>
        <Header />
        <DocumentHead
          title={`${title} by ${story.spacePath}`}
          description={story.bodySnippet}
          imagePath={imageSrc(story.avatar)}
        />
        <CoverImage src={src} key='image' alt={title} />
        <Article>
          <Title>{title}</Title>
          <StoryInfo story={story} />
          <StoryWrapper margin='25px auto 0 auto'>
            <Editor store={store} />
          </StoryWrapper>
          <TagLinks tags={story.tags} />
          <Like content={story.content} />
          <Divider width='100%' margin='20px auto 0px auto' />
        </Article>
        <AuthorDetails story={story} />
        <SectionBanner
          bannerId='story-comments'
          imageSrc='/assets/banners/005.svg'
          title='Experience Collaborative Manufacturing'
          buttonText='Learn more'
          linkName='https://wikifactory.com'
          paddingTop='large'
          paddingBottom='xlarge'
        >
          <Box>
            <Paragraph>
              <strong>Share, iterate, prototype</strong> and{' '}
              <strong>manufacture</strong> your hardware products completely
              online.
            </Paragraph>
            <Paragraph>
              Adopted by a <strong>global community of over 140,000</strong>{' '}
              engineers, designers, SMEs and hardware startups.{' '}
            </Paragraph>
            <Paragraph>
              <strong>Driving innovation across industries</strong> from
              robotics and drones to electric vehicles, 3D printers, bio-tech,
              agri-tech, and smart furniture.
            </Paragraph>
          </Box>
        </SectionBanner>
        <Comments story={story} params={params} />
      </Main>
    );
  }
}

StoryView.propTypes = {
  story: PropTypes.object,
  params: PropTypes.object,
  loading: PropTypes.bool,
};
